import Axios from '@/config/AxiosConfig';
export const addTimeline = async (payload) => {
    const url = '/timeline/add';

    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const getAllTimeLine = async () => {
    const url = `/timeline/get-timelines`;
    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
}

export const getTimelineDropDownList = async () => {
    const url = `timeline/get-items`;
    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
}

export const addTimelineNote = async (payload) => {
    const url = '/timeline/add-notes';

    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const addChecklistToTimeline = async (payload) => {
    const url = "/timeline/add-checklist";
    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const updateChecklistToTimeline = async (payload) => {
    const url = "/timeline/update-checklist";
    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

const serialize = (obj) =>  {
    var str = [];
    for (var p in obj)
        if (obj.hasOwnProperty(p)) {
            if((!Array.isArray(obj[p]) &&  obj[p]) || (Array.isArray(obj[p]) && obj[p].length) ){
                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            }
        }
    return str.join("&");
}

// http://pms6-api.gnomen.io/api/v1/timeline/get-timeline-by-type/note/3
export const getTimelineByType = async (type, id) => {
    const url = `/timeline/get-timeline-by-type/${type}/${id}`;
    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
}
// http://pms6-api.gnomen.io/api/v1/timeline/get-timeline-by-type/note/3
export const getDocumentTemplate = async (payload, id) => {
    const url = `document-template/get-document-template?template_id=${id}&${serialize(payload)}`;
    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
}

// http://pms6-api.gnomen.io/api/v1/timeline/update-notes
export const updateTimelineNotes = async (payload) => {
    const url = `/timeline/update-notes`;
    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
}

